import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { EntitlementsProvider } from "@/lib/entitlements";
import Home from "@/pages/Home";
import Landing from "@/pages/Landing";
import OnboardingFlow from "@/pages/OnboardingFlow";
import Transition from "@/pages/Transition";
import RequireEntitlement from "@/components/RequireEntitlement";
import { SeoMeta } from "@/components/SeoMeta";
import AdminDashboard from "@/pages/AdminDashboard";
import Scorecard from "@/pages/Scorecard";
import History from "@/pages/History";
import SignIn from "@/pages/SignIn";
import Settings from "@/pages/Settings";
import Paywall from "@/pages/Paywall";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Support from "@/pages/Support";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function App() {
  return (
    <AuthProvider>
      <EntitlementsProvider>
        <BrowserRouter>
          <SeoMeta />
          <div className="app-bg" />
          <div className="shell">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/onboarding" element={<OnboardingFlow />} />
              <Route path="/transition" element={<Transition />} />
              <Route path="/app" element={<RequireEntitlement><Home /></RequireEntitlement>} />
              <Route path="/scorecard" element={<RequireEntitlement><Scorecard /></RequireEntitlement>} />
              <Route path="/scorecard/:id" element={<RequireEntitlement><Scorecard /></RequireEntitlement>} />
              <Route path="/history" element={<RequireEntitlement><History /></RequireEntitlement>} />
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/paywall" element={<Paywall />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/support" element={<Support />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>
          </div>
          <Toaster
            theme="dark"
            position="top-center"
            toastOptions={{
              style: {
                background: "#121214",
                border: "1px solid #242428",
                color: "#fafafa",
              },
            }}
          />
        </BrowserRouter>
      </EntitlementsProvider>
    </AuthProvider>
  );
}

export default App;
